import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Report} from '../../../graphql/reports.datatypes';

interface DeleteReportVars {
    id: number;
}

interface DeleteReportData {
    deleteReport: Report
}

export const DELETE_REPORT_MUTATION = gql`
    mutation deleteReport($id: Int!) {
        deleteReport(id: $id) {
          id
        }
    }
`;

export const deleteReport = () => useMutation<DeleteReportData, DeleteReportVars>(
  DELETE_REPORT_MUTATION,
    {
        update: updateCacheByType('Report'),
    }
);

export default deleteReport;